import { init as initConfig, setup as setupConfig, getConfig } from '@cian/config/browser';
import { setup as setupTelemetry } from '@cian/telemetry/browser';
import { init as initHttpApi, setup as setupHttpApi } from '@cian/http-api/browser';
import { registerFragment } from '@cian/fragment/browser/register';
import { BROWSER_CONFIG_SETTINGS_KEY } from '../shared/constants';
import { CommercialOfferCard } from '../shared/commercial-card';
import { OfferCard } from '../shared/offer-card';
import { TopOfferCard } from '../shared/TopOfferCard';
import { SlonoTopCard } from '../shared/slono-top-card';
import { withProps as createWithPropsWrapper } from './enhancers/withProps';

setupConfig({
  settingsKey: BROWSER_CONFIG_SETTINGS_KEY,
});
setupTelemetry();
setupHttpApi({});

initConfig();
const config = getConfig();
const httpApi = initHttpApi();

const withProps = createWithPropsWrapper({
  config,
  httpApi,
});

registerFragment('offerCardFragment', withProps(OfferCard));
registerFragment('commercialCardFragment', withProps(CommercialOfferCard));
registerFragment('topOfferCardFragment', withProps(TopOfferCard));
registerFragment('slonoTopCardFragment', withProps(SlonoTopCard));

// tslint:disable-next-line:no-any
if ((module as any).hot) {
  // tslint:disable-next-line:no-any
  (module as any).hot.accept();
}
